import { AfterViewInit, Component, CUSTOM_ELEMENTS_SCHEMA, inject, viewChild } from '@angular/core';
import { internalUrl } from '../lib/Urls';
import { HttpClient } from '@angular/common/http';
import { WjFlexGrid, WjGridModule } from '@mescius/wijmo.angular2.grid';
import { Modals } from '../lib/Modals';
import { MonacoEditorComponent } from '../monaco-editor/monaco-editor.component';
import { NgDynamicComponentsService } from '../service/ng-dynamic-components.service';

@Component({
    selector: 'app-custom-xml-list',
    templateUrl: './custom-xml-list.component.html',
    styleUrls: ['./custom-xml-list.component.scss'],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    imports: [
        WjGridModule
    ],
    standalone: true
})
export class CustomXmlListComponent implements AfterViewInit {

    parts: Excel.CustomXmlPart[] = [];
    private dialog: Office.Dialog;

    grid = viewChild.required<WjFlexGrid>('grid');

    private readonly dynCompSvc = inject(NgDynamicComponentsService);

    constructor(private http: HttpClient) { }

    async ngAfterViewInit(): Promise<void> {
        await this.listCustomXml();
    }

    async listCustomXml() {
        try {
            await Excel.run(async context => {
                context.workbook.customXmlParts.load();
                await context.sync();
                this.parts = context.workbook.customXmlParts.items
                this.grid().itemsSource = this.parts;
            });
        } catch (error) {
            console.error(error);
        }
    }

    async onDoubleClick(event: MouseEvent) {
        // await this.showXmlInEditor((event.rowData as Excel.CustomXmlPart).id);
    }

    async showSelectedXmlInEditor() {
        await this.showXmlInEditor((this.grid().selectedItems[0] as Excel.CustomXmlPart).id);
    }

    async showXmlInEditor(xmlId: string) {
        await Excel.run(async  context => {
            const part = context.workbook.customXmlParts.getItem(xmlId);
            part.load('xml/value');
            const xml = part.getXml();
            await context.sync();
            // localStorage.setItem('editor.mode', 'xml');
            // localStorage.setItem('editor.content', xml.value);
            MonacoEditorComponent.openDialog(this.dynCompSvc, {
                title: 'XML',
                width: 'min(80vw, 1000px)',
                input: { initialValue: xml.value, language: 'xml', fontSize: 8 },
            });
        });
    }

    private sendDialogMessage(dialog: Window, value: string, count: number = 0) {
        if (dialog['onMessageFromParent']) {
            dialog['onMessageFromParent'](value);
        } else if (count > 10) {
            console.error('Could not send message to dialog');
        } else {
            setTimeout(() => this.sendDialogMessage(dialog, value, ++count), 100);
        }
    }


    openDialog(): Window {
        return Modals.popupCenter(internalUrl('/editor'), 'Editor', 600, 800);
    }

    openDialog2(): Promise<Office.Dialog> {
        const url = internalUrl('/editor');
        console.log(url);

        return new Promise((resolve, reject) => {
            Office.context.ui.displayDialogAsync(
                url,
                {
                    height: 50,
                    width: 60,
                    promptBeforeOpen: false
                },
                result => {
                    this.dialog = result.value;
                    resolve(this.dialog)
                });
        });
    }

    sendMessage() {
        this.http.get('https://dev.etractive.de/py/hello', { observe: 'response' }).subscribe((res) => {
            console.log(res.body);
        });
    }
}
